<template>
  <Switch :value="modelValue" @update:modelValue="$emit('update:modelValue', !modelValue)"
          class="flex-shrink-0 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2"
          :class="colors[color].focus">
    <span aria-hidden="true" class="pointer-events-none absolute bg-white w-full h-full rounded-md"/>
    <span aria-hidden="true"
          :class="[modelValue ? colors[color].bg : 'bg-gray-200', 'pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200']"/>
    <span aria-hidden="true"
          :class="[modelValue ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200']"/>
  </Switch>
</template>

<script>
import {ref} from 'vue'
import {Switch} from '@headlessui/vue'

export default {
  components: {
    Switch,
  },
  props: {
    color: {
      default: 'primary'
    },
    modelValue: {
      type: Boolean,
    }
  },
  setup() {
    const enabled = ref(false)
    const colors = {
      primary: {
        focus: 'focus:ring-primary-500',
        bg: 'bg-primary-600'
      },
      green: {
        focus: 'focus:ring-green-500',
        bg: 'bg-green-600'
      },
    };
    return {
      enabled, colors
    }
  },

}
</script>

